const messages = {
    en: {
        delivery: {
            branch: {
                name: 'Branch',
                title: 'Branch management',
                subtitle: 'View, search, create, edit and delete Branch',
                creating: 'Creating Branch',
                editing: 'Editing Branch',
                deleting: 'Deleting Branch',
                showing: 'Showing Branch',
                menu: 'Branch',
                labels: {
                    name: 'Name',
                    role: 'Role',
                    isDefault: 'Is default'
                },
                roles: {
                    FACTORY: 'Factory',
                    SALES: 'Sales',
                    HYBRID: 'Hybrid',
                }

            }
        }
    },
    es: {
        delivery: {
            branch: {
                name: 'Sucursal',
                title: 'Administración de sucursales',
                subtitle: 'Ver, buscar, crear, editar, y borrar sucursales',
                creating: 'Creando Sucursal',
                editing: 'Modificando Sucursal',
                deleting: 'Eliminando Sucursal',
                showing: 'Detalles de Sucursal',
                menu: 'Sucursales',
                labels: {
                    name: 'Nombre',
                    role: 'Rol',
                    isDefault: 'Por defecto'
                },
                roles: {
                    FACTORY: 'Fabrica',
                    SALES: 'Ventas',
                    HYBRID: 'Hibrido',
                }

            }
        }
    },
    pt: {
        delivery: {
            branch: {
                name: 'Sucursal',
                title: 'Administração de Branch',
                subtitle: 'Ver, buscar, criar, editar e usar Branch',
                creating: 'Criando Branch',
                editing: 'Edição Branch',
                deleting: 'Apagando Branch',
                showing: 'Detalhes do Branch',
                menu: 'Branch',
                labels: {
                    name: 'Nome',
                    role: 'Rol',
                    isDefault: 'Is default'
                },
                roles: {
                    FACTORY: 'Factory',
                    SALES: 'Sales',
                    HYBRID: 'Hybrid',
                }

            }
        }
    }
}

export default messages
